/**
 *
 * AppUpdateProgress
 *
 */

import React, { memo } from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Progress } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';

function AppUpdateProgress({
  visibility,
  progress,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('appp-update-progress', className);
  //const { isMobile } = useDeviceDetect();

  return (
    !!visibility && (
      <div className={childClassNames}>
        <div className="appp-update-progress__header">
          <CustomIcons className="logo-login" type="logo" />
        </div>
        <div className="appp-update-progress__container">
          <Progress
            type="circle"
            strokeColor={{
              '0%': '#28a745',
              '50%': '#68cf9a',
              '100%': '#61b390',
            }}
            trailColor="rgba(86, 146, 189, .4)"
            percent={Number(progress)}
            status={Number(progress) > 0 && Number(progress) != 100 ? "active" : ( Number(progress) >= 100 ? "success": "normal" )}
          />
        </div>
      </div>
    )
  );
}

AppUpdateProgress.defaultProps = {
  progress: 0,
  visibility: false,
};

export default memo(AppUpdateProgress);
